<template>

<h1>5</h1>

</template>

<script>
export default {
  name: "Button1",


  data() {
    return    {


    }
  },

  methods : {

  }
}
</script>

<style scoped>



</style>
